import { useRef } from "react";
import "./infiniteScrollWithObserver.scss";

import { useIntersectionObserver } from "@src/utils/hooks/useInterSectionObsever";

import LoadingSpinner from "@src/components/common/loading/LoadingSpinner";

export default function InfiniteScrollWithObserver(props: {
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  observerPositionFromBottom: number;
  className?: string;
  children: React.ReactNode;
}) {
  const observeBox = useRef<HTMLDivElement>(null);

  useIntersectionObserver({
    target: observeBox,
    onIntersect: props.fetchNextPage,
    enabled: props.hasNextPage === true && props.isFetchingNextPage === false,
  });

  return (
    <div className="infinite-scroll-with-observer-container">
      <div className={`infinite-scroll-list ${props.className}`}>{props.children}</div>

      {props.isFetchingNextPage === true && (
        <div className="infinite-scroll-loading">
          <LoadingSpinner position="absolute" />
        </div>
      )}

      {/* 여기 div가 관찰 대상 */}
      {props.hasNextPage === true && props.isFetchingNextPage === false && (
        <div
          ref={observeBox}
          className="observe-box"
          style={{
            bottom: `${props.observerPositionFromBottom}px`,
          }}
        />
      )}
    </div>
  );
}
